<template>
    <!-- 报告-按部门 -->
    <div v-loading="loading" class="business-expense-name">
        <container-title title="报告-按部门" />
        <div class="main-container-content">
            <el-form label-width="110px" class="search-form">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="报表截止月份">
                            <el-date-picker v-model="yearMonth" type="month" format="yyyy年MM月" value-format="yyyyMM"
                                :disabled="loading" :clearable="false" placeholder="请选择报表截止月份" class="mid-el-width" @change="refresh">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="总部职能部门">
                            <el-select
                                :disabled="loading"
                                v-model="firstDeptId"
                                @change="fetchList"
                                filterable
                                placeholder="请选择部门"
                                class="full-width-select"
                            >
                                <el-option
                                    v-for="item in firstDeptList"
                                    :key="item.dicId"
                                    :label="item.dicName" 
                                    :value="item.dicId"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <div class="budget-info-text">
                            执行数据：{{ resData.budgetYear }}年{{ resData.executeMonth }}月 | 预算口径：{{ resData.budgetYear }}年{{ yearTimes }}
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="24">
                    <el-col :span="24">
                        <div class="status-actions-wrapper">
                            <div class="left-status">
                                <span class="status-label">状态:</span>
                                <span class="status-value">{{ archiveStatus | reportStatusFilters }}</span>
                            </div>
                            <div class="right-btns left-status">
                                <span class="status-label">单位：万元</span>
                                <el-button class="ml-10" v-throttle="[archiveReport,`click`,1000]" :disabled="loading" type="primary"
                                    >{{ archiveStatus == 1 ? '取消归档' : '全部归档' }}</el-button>
                                <el-button class="ml-10" v-show="archiveStatus == 1" :disabled="loading" v-throttle="[sendEmial,`click`,1000]">发送邮件</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <div class="mb-12">
            </div>
            <h2 class="table-title">{{ currentDeptName }}</h2>
            <h2 class="table-subtitle">{{ resData.budgetYear || '' }}年{{ resData.executeMonth || '' }}月预算执行情况分析</h2>
            <el-table
                ref="tableRef"
                :data="processedTableData"
                border
                :max-height="tableHeight"
                :cell-style="getCellStyleByColumn(resData.executeRate)"
                :row-class-name="tableRowClassName"
                class="budget-report-table"
            >
                <!-- 一级预算单位名称列 -->
                <el-table-column prop="firstDeptName" label="一级预算单位名称" min-width="150" fixed="left" align="left">
                    <template slot-scope="scope">
                        <el-tooltip 
                            v-if="shouldShowTooltip(scope.$index)" 
                            :content="scope.row.firstDeptName" 
                            placement="top"
                            effect="dark"
                        >
                            <span :class="getfirstDeptNameClass(scope.$index, scope.row)">{{ scope.row.firstDeptName }}</span>
                        </el-tooltip>
                        <span v-else :class="getfirstDeptNameClass(scope.$index, scope.row)">{{ scope.row.firstDeptName }}</span>
                    </template>
                </el-table-column>
                <!-- 序号 -->
                <el-table-column prop="orderIndex" label="序号" min-width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isTotalRow || scope.row.isSubRow"></span>
                        <div v-else-if="scope.row.isMainRow" style="display: flex; align-items: center; justify-content: space-between;">
                            <span>{{ scope.row.orderIndex }}</span>
                            <i 
                                v-if="scope.row.hasSubRows"
                                :class="scope.row.isExpanded ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline'" 
                                @click="toggleRowExpand(scope.row)"
                                style="cursor: pointer; margin-left: 5px;"
                            ></i>
                        </div>
                        <span v-else>{{ scope.row.orderIndex || '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" show-overflow-tooltip label="预算大类" min-width="150" align="right">
                </el-table-column>
                <el-table-column prop="childType" show-overflow-tooltip label="预算类型" min-width="150" align="right">
                </el-table-column>
                <!-- 预算 -->
                <el-table-column prop="businessAmount" :label="`${resData.budgetYear || ''}年${resData.halfMonth || ''}月预算（经营预算）`" min-width="250" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.businessAmount) }}
                    </template>
                </el-table-column>
                <!-- 当年实际 -->
                <el-table-column prop="executeAmount" :label="`${resData.budgetYear || ''}年${resData.executeMonth || ''}月实际`" min-width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="executeAmountLoan" label="未核销借款" min-width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmountLoan) }}
                    </template>
                </el-table-column>
                <!-- 执行合计 -->
                <el-table-column prop="executeTotal" :label="`${resData.budgetYear || ''}年${resData.executeMonth || ''}月执行合计`" min-width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeTotal) }}
                    </template>
                </el-table-column>
                <el-table-column prop="budgetExecuteRate" :label="`预算执行率（整体）`" min-width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatPercent(scope.row.budgetExecuteRate) }}
                    </template>
                </el-table-column>
                <!-- 预算剩余值 -->
                <el-table-column prop="budgetRemaining" label="预算剩余值" min-width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.budgetRemaining) }}
                    </template>
                </el-table-column>
                <el-table-column prop="exceedWarning" label="超出提示(按时间进度)" min-width="230" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.exceedWarning || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="出现超标情况说明" min-width="300" align="right">
                    <template slot-scope="scope">
                        <div class="cell-content">
                            <editable-text-cell
                                :value="scope.row.remark"
                                :disabledProp="true"
                                :editing="editingCell && editingCell.rowIndex === scope.$index && editingCell.field === 'remark'"
                                @edit="handleEdit(scope.$index, 'remark')"
                                @save="handleSave(scope.$index, 'remark', $event)"
                                @cancel="handleCancelEdit"
                            />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="executeAmountWaitShare" label="待分摊金额" min-width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmountWaitShare) }}
                    </template>
                </el-table-column>
                <el-table-column prop="deviationAmount" label="偏差额" min-width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.deviationAmount) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
        <!-- 发送邮件弹窗 -->
        <email-dialog
            :visible.sync="emailDialogVisible"
            :params="emailParams"
            :title="currentDeptName + resData.budgetYear + '年' + resData.executeMonth + '月预算执行情况分析'"
            @success="handleEmailSuccess"
        />
    </div>
</template>
<script>

import { defineComponent, ref, reactive, onMounted, onBeforeUnmount, getCurrentInstance, computed, nextTick } from 'vue'
import { awaitWrapper, downloadFileFromUrl } from "@/common/utils/assist.js";
import { usePageDto } from '@/common/mixins/usePageDto'
import { useSetTableHeight } from '@/common/mixins/useSetTableHeight'

import { preMonth } from '@/common/functions/formatters'
import { currencyNoSymbol } from "@/common/utils/assist.js";

import {
    queryReportBranchType,
    archiveReportBranchType, // 归档 1归档 2取消归档 3导出 4查询
    exportReportBranchType, // 导出数据
    modReportHeadTypeChildTypeDeptRemark, // 修改情况说明
} from './request.js'

import { processReportByDeptData, getCellStyleByColumn, queryFirstDepts } from './handleReportByDept.js'
import EditableTextCell from '../HeadquarterByCategory/EditableTextCell.vue'
import EmailDialog from './EmailDialog.vue'
import {
    reportStatusFilters
} from '../util.js'
export default defineComponent({
    components: {
        EditableTextCell,
        EmailDialog
    },
    filters: {
        reportStatusFilters: reportStatusFilters
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance()
        const loading = ref(false)
        const yearMonth = ref(preMonth())
        const resData = ref({})
        const initTableData = ref([]) // 表格数据
        const archiveStatus = ref(0) // 归档 0未归档 1已归档
        
        const firstDeptList = ref([])
        const firstDeptId = ref(null)
        const currentDeptName = ref('') // 当前部门名称
        
        // 展开的主行 typeId 列表
        const expandedRows = ref([])
        
        // 当前编辑的单元格
        const editingCell = ref(null)
        
        // 发送邮件弹窗
        const emailDialogVisible = ref(false)
        const emailParams = computed(() => ({
            // firstDeptId: firstDeptId.value,
            yearMonth: yearMonth.value,
            type: 3
        }))
        const fetchList = async (type) => {
            editingCell.value = null
            expandedRows.value = [] // 重置展开状态
            
            const params = {
                firstDeptId: firstDeptId.value,
                yearMonth: yearMonth.value,
                type: ![1,2,3,4].includes(type) ? 4 : type, // 操作 1归档 2取消归档 3导出 4查询
            }
            const deptItem = firstDeptList.value.find(item => item.dicId === firstDeptId.value)
            const firstDeptName = deptItem ? deptItem.dicName : ''
            params.firstDeptName = firstDeptName
            currentDeptName.value = firstDeptName // 保存当前部门名称
            loading.value = true
            const [, res] = await awaitWrapper(queryReportBranchType(params))
            loading.value = false
            
            if (res && res.code == 0 && res.data) {
                resData.value = res.data
                archiveStatus.value = res.data.archiveStatus || 0
                
                const rawList = res.data.reportDetailList || []
                initTableData.value = [...rawList]
            }
        }
        const archiveReport = async () => { // 归档 0未归档 1已归档
            // 二次确认
            const confirmMessage = archiveStatus.value == 1 ? '是否确认取消归档？' : '是否确认归档所有部门的数据？'
            try {
                await proxy.$confirm(confirmMessage, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                
                // 用户确认后执行归档操作
                const params = {
                    yearMonth: yearMonth.value,
                    type: archiveStatus.value == 1 ? 2 : 1, // 1归档 2取消归档 3导出 4查询 
                }
                loading.value = true
                const [, res] = await awaitWrapper(archiveReportBranchType(params))
                loading.value = false
                if (res && res.code == 0) {
                    proxy.$message.success(archiveStatus.value === 1 ? '取消归档成功' : '归档成功')
                    fetchList(4)
                }
            } catch (error) {
                // 用户取消操作，不做任何处理
            }
        }

        // 计算处理后的表格数据
        const processedTableData = computed(() => {
            // 从 executeMonth（如 "1-2"）取第二位数字作为参数
            const executeMonthStr = resData.value.executeMonth
            const executeMonthSecond = executeMonthStr && String(executeMonthStr).indexOf('-') !== -1
                ? parseInt(String(executeMonthStr).split('-')[1], 10)
                : (executeMonthStr ? parseInt(executeMonthStr, 10) : undefined)
            // 使用 processReportByDeptData 函数处理数据
            const processedData = processReportByDeptData(
                initTableData.value,
                resData.value.executeRate,
                currentDeptName.value,
                executeMonthSecond
            )
            
            // 根据 expandedRows 更新展开状态
            return processedData.map(row => {
                if (row.isMainRow) {
                    row.isExpanded = expandedRows.value.includes(row.typeId)
                }
                return row
            }).filter(row => {
                // 过滤副行：只显示已展开主行的副行
                if (row.isSubRow) {
                    return expandedRows.value.includes(row.typeId)
                }
                return true
            })
        })

        // 格式化数字（四舍五入两位小数）
        const formatNumber = (value) => {
            if (value === null || value === undefined) {
                return '--'
            }
            return currencyNoSymbol(value)
        }

        // 格式化百分比
        const formatPercent = (value) => {
            if (value === null || value === undefined) {
                return '/'
            }
            if (value > -0.4 && value < 0.4) {
                return '0%'
            }
            return parseFloat(value).toFixed(0) + '%'
        }

        // 表格行样式
        const tableRowClassName = ({ row, rowIndex }) => {
            if (row.isTotalRow) {
                return 'summary-row'
            }
            return ''
        }

        // 部门名称样式（根据行数判断）
        const getfirstDeptNameClass = (rowIndex, row) => {
            if (rowIndex === 0) {
                return 'dept-name-group-summary'
            }
            return 'dept-name-normal'
        }

        const tableRef = ref(null)
        const { pageDto, refresh, changePage, changeSize } = usePageDto(fetchList, tableRef)
        const height = ref(180)
        const { tableHeight, calcHeight } = useSetTableHeight({
            height: height.value,
            pageDto: pageDto,
            tableRef: tableRef
        })


        onMounted(async () => {
            firstDeptList.value = await queryFirstDepts()
            firstDeptId.value = firstDeptList.value[0].dicId
            fetchList(4)
        })

        const exportAll = async () => {
            const params = {
                yearMonth: yearMonth.value,
                type: 3,
            }
            loading.value = true
            const [, res] = await awaitWrapper(exportReportBranchType(params))
            loading.value = false
            if (res && res.code == 0) {
                try {
                    loading.value = true
                    await downloadFileFromUrl(res.data, '预算分析报表-报告-按部门-' + yearMonth.value.slice(0, 4) + '年' + yearMonth.value.slice(4, 6) + '月.xlsx')
                    loading.value = false
                    proxy.$message.success('导出成功')
                } catch (error) {
                    loading.value = false
                }
            }
        }
        // 判断是否需要显示悬浮提示
        const shouldShowTooltip = (rowIndex) => {
            return true
        }

        // 计算上半年/下半年显示
        const yearTimes = computed(() => {
            if (!resData.value.halfMonth) {
                return ''
            }
            const halfMonthStr = String(resData.value.halfMonth)
            return halfMonthStr.startsWith('1') ? 'H1' : 'H2'
        })
        
        // 切换行展开/收起
        const toggleRowExpand = (row) => {
            if (!row.isMainRow || !row.hasSubRows) {
                return
            }
            
            const index = expandedRows.value.indexOf(row.typeId)
            if (index > -1) {
                expandedRows.value.splice(index, 1) // 收起
            } else {
                expandedRows.value.push(row.typeId) // 展开
            }
        }
        
        // 开始编辑
        const handleEdit = (rowIndex, field) => {
            editingCell.value = { rowIndex, field }
        }

        // 取消编辑
        const handleCancelEdit = () => {
            editingCell.value = null
        }

        // 保存编辑
        const handleSave = async (rowIndex, field, value) => {
            const currentRow = processedTableData.value[rowIndex]
            if (!currentRow) {
                return
            }
            
            // 更新数据
            const params = {
                typeId: currentRow.typeId,
                childTypeId: currentRow.childTypeId || 0,
                firstDeptId: firstDeptId.value,
                yearMonth: yearMonth.value,
                remark: value || ''
            }
            loading.value = true
            const [, res] = await awaitWrapper(modReportHeadTypeChildTypeDeptRemark(params))
            loading.value = false
            if (res && res.code == 0) {
                proxy.$message.success('修改成功')
                fetchList(4)
                setTimeout(() => {
                    editingCell.value = null
                }, 100)
            }
        }
        
        // 发送邮件
        const sendEmial = () => {
            emailDialogVisible.value = true
        }
        
        // 邮件发送成功回调
        const handleEmailSuccess = () => {
            fetchList(4) // 刷新列表
        }
        return {
            tableRef,
            tableHeight,
            calcHeight,
            loading,
            yearMonth,
            firstDeptId,
            firstDeptList,
            currentDeptName,
            expandedRows,
            editingCell,
            pageDto,
            refresh,
            changePage,
            changeSize,
            archiveStatus,
            archiveReport,
            exportAll,
            resData,
            processedTableData,
            formatNumber,
            formatPercent,
            tableRowClassName,
            getfirstDeptNameClass,
            getCellStyleByColumn,
            shouldShowTooltip,
            yearTimes,
            fetchList,
            toggleRowExpand,
            handleEdit,
            handleCancelEdit,
            handleSave,
            sendEmial,
            emailDialogVisible,
            emailParams,
            handleEmailSuccess
        }
    },
})
</script>
<style lang="scss" scoped>
.main-container-content {
    padding: 20px;
    background-color: #fff;
}

.business-expense-name {
    background: #fff;
    -webkit-box-shadow: 0 2px 4px 0 #dbdee7;
    box-shadow: 0 2px 4px 0 #dbdee7;
    border-radius: 4px;
    margin: 16px;
}

.ml-10 {
    margin-left: 10px;
}

.mb-12 {
    margin-bottom: 12px;
}

.table-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.table-subtitle {
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    margin-bottom: 20px;
}

.cell-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-form {
    width: 100%;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
}

.status-actions-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    flex: 1;
}

.left-status {
    display: flex;
    align-items: center;
    padding-left: 15px;
    font-size: 14px;

    .status-label {
        color: #909399;
        margin-right: 8px;
    }

    .status-value {
        color: #409EFF;
        font-weight: 500;
        padding: 2px 8px;
        background-color: #ecf5ff;
        border-radius: 3px;
    }
}

.right-btns {
    display: flex;
    gap: 10px;
}

.budget-info-text {
    padding-left: 15px;
    font-size: 14px;
    color: #606266;
    line-height: 32px;
}

// 表格样式
.budget-report-table {
    ::v-deep .el-table__header {
        th {
            background-color: #c70000 !important; // 深红色背景
            color: #fff !important; // 白色文字
            font-weight: bold;
            text-align: center;
            .cell {
                color: #fff !important; // 白色文字
                font-weight: bold;
            }
        }
    }

    // 集团汇总行（浅黄色背景）
    ::v-deep .group-summary-row {
        background-color: #fff5d0 !important; // 浅黄色
        font-weight: bold;
    }

    // 其他汇总行（浅灰色背景）
    ::v-deep .summary-row {
        background-color: #dedede !important; // 浅灰色
        font-weight: bold;
    }

    // 子项行（白色背景，缩进）
    ::v-deep .sub-item-row {
        background-color: #fff;
    }

    // 部门名称样式
    .dept-name-group-summary {
        font-weight: bold;
        color: #000;
    }

    .dept-name-summary {
        font-weight: bold;
        color: #000;
    }

    .dept-name-sub-item {
        padding-left: 20px;
        color: #000;
    }

    .dept-name-normal {
        color: #000;
    }
}
.budget-report-table {
    ::v-deep .el-table__header {
        th {
            background-color: #c70000 !important;
            color: #fff !important;
            font-weight: bold;
            text-align: center;
            border-color: #333 !important;
            .cell {
                color: #fff !important;
                font-weight: bold;
            }
        }
    }

    // 集团汇总行（浅黄色背景）
    ::v-deep .group-summary-row {
        background-color: #fff5d0 !important;
        font-weight: bold;
        
        td {
            border-color: #333 !important;
        }
    }

    // 其他汇总行（浅灰色背景）
    ::v-deep .summary-row {
        background-color: #dedede !important;
        font-weight: bold;
        
        td {
            border-color: #333 !important;
        }
    }

    // 子项行（白色背景，缩进）
    ::v-deep .sub-item-row {
        background-color: #fff;
        
        td {
            border-color: #333 !important;
        }
    }

    // ... 其他样式保持不变
}
::v-deep .el-table--group, ::v-deep .el-table--border th, ::v-deep .el-table--border td {
    border-color: #999 !important;
}
/* 消除固定列残影 - 综合方案 */
::v-deep .el-table__fixed,
::v-deep .el-table__fixed-right {
    /* 强制硬件加速 */
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    perspective: 1000px;
    -webkit-perspective: 1000px;
    
    /* 层级和定位 */
    z-index: 11 !important;
    position: absolute !important;
    
    /* 隐藏溢出，防止残影 */
    overflow: hidden !important;
    
    /* 优化渲染 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* 优化固定列阴影 */
::v-deep .el-table__fixed {
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.12) !important;
    right: auto !important;
}

/* 固定列内部容器也需要优化 */
::v-deep .el-table__fixed-header-wrapper,
::v-deep .el-table__fixed-body-wrapper,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper,
::v-deep .el-table__fixed-right .el-table__fixed-body-wrapper {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    overflow: hidden !important;
}

/* 表格主容器优化 */
::v-deep .el-table {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
}

/* 表格body优化，防止滚动时产生残影 */
::v-deep .el-table__body-wrapper {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    overflow: auto !important;
}

// 只针对包含 .cell-content 的单元格
::v-deep .el-table__cell:has(.cell-content) {
    padding: 0 !important;
    height: 100%;
    
    .cell {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
